import { FC, MouseEventHandler } from 'react'

import { Title, Text, Button, Icon } from '../../'

type FormMessageErrorProps = {
  className?: string,
  title?: string,
  message?: string,
  buttonText?: string,
  onClick: MouseEventHandler<HTMLButtonElement>
}

const FormMessageError:FC<FormMessageErrorProps> = ({ className = '', title = 'Ha ocurrido un error', message = '', buttonText = 'REINTENTAR', onClick })  => {
  return (
    <div className={`text-center ${className}`}>
      <Icon name="modal-error" />
      <Title component="h4" size="20" weight="bold" className="mt-20">{title}</Title>
      <Text className="mt-20">{message}</Text>
      <Button className="mt-30" onClick={onClick}>{buttonText}</Button>
    </div>
  )
}

export { FormMessageError }